<template>
  <overlay-modal ref="overlayModal" width="65%" :hide-close="true">
    <template v-slot:header>
      <div class="d-md-flex justify-content-between">
        <h4 class="cursive">Completa il tuo preventivo!</h4>
        <div class="d-flex justify-content-between d-md-block">
          <button
            id="generaPreventivo"
            class="btn btn-primary mx-1"
            @click="onConfirm"
          >
            Completa
          </button>
          <button class="btn btn-secondary mx-1" @click="onReset">
            Annulla
          </button>
        </div>
      </div>
    </template>
    <template>
      <div class="container">
        <div class="border-top border-secondary py-1">
          <SummaryPreventivo />
        </div>
        <div class="mt-2 border-top border-secondary pb-3">
          <div class="d-flex justify-content-center">
            <h6
              class="text-uppercase mb-0 position-relative bg-white px-2"
              style="top: -8px"
            >
              Per persona
            </h6>
          </div>
          <div class="d-flex justify-content-center">
            <h1 class="text-uppercase mx-2 mb-0">
              {{ totalePerPersona }} &euro;
            </h1>
            <div class="mx-2 d-flex mt-2">
              <h5 style="line-height: 25px" class="mr-2">Totale</h5>
              <h4 class="default-bold">{{ totale }} &euro;</h4>
            </div>
          </div>
        </div>
        <div class="bg-secondary text-white px-3 py-2 mb-1">
          <h5 class="cursive mb-0">
            Quota di gestione pratica e assicurazioni selezionate
          </h5>
        </div>
        <SpesePanel
          v-for="(item, index) in list"
          :index="index"
          :key="index"
          :value="item"
          class="mb-1"
        />
      </div>
    </template>
  </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OverlayModal from "../../../modals/OverlayModal";
import SpesePanel from "../SpesePanel";
import { formatMoney } from "../../../../utils/formatter";
import SummaryPreventivo from "../SummaryPreventivo";
import AnalyticEvents from "../../../common/AnalyticEvents";
import ContentUtils from "../../../utils/ContentUtils";
import {
  PRODUCT_VOLO_HOTEL,
  PRODUCT_TOUR,
  PRODUCT_EXPERIENCE,
} from "../../../../types/products";

export default {
  name: "ModalSpesePratica",
  mixins: [AnalyticEvents, ContentUtils],
  components: { SummaryPreventivo, SpesePanel, OverlayModal },
  data() {
    return {
      gtagData: {},
    };
  },
  computed: {
    list() {
      return this.getSpeseAccessorie();
    },
    summary() {
      return this.getSummary();
    },
    totalePerPersona() {
      return formatMoney(this.summary.totalPricePerPerson);
    },
    totale() {
      return formatMoney(this.summary.totalPrice);
    },
  },
  methods: {
    ...mapGetters([
      "getSpeseAccessorie",
      "getSummary",
      "getSelectedHotels",
      "getTrasferimentiSelected",
      "getSelectedTour",
      "getServiziSelected",
      "isExperience",
      "isVoloHotel",
      "isTour",
      "updateData",
    ]),
    ...mapActions(["resetSpese"]),
    updateData(data) {
      this.gtagData = data;
    },
    isVoloHotel() {
      return this.getSearch().product === PRODUCT_VOLO_HOTEL;
    },
    isTour() {
      return this.getSearch().product === PRODUCT_TOUR;
    },
    isExperience() {
      return this.getSearch().product === PRODUCT_EXPERIENCE;
    },
    onConfirm() {
      this.trackGtmModaleCompletaPreventivoConcludi(this.gtagData);
      this.trackModaleCompletaPreventivoConcludi();
      this.$emit("confirm");
      this.close();
    },
    onReset() {
      this.trackModaleCompletaPreventivoAnnulla();
      this.resetSpese();
      this.close();
    },
    open() {
      this.$refs.overlayModal.open();
    },
    openWithTag(data) {
      this.updateData(data);
      this.$refs.overlayModal.open();
    },
    close() {
      this.$refs.overlayModal.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalSpesePratica.vue